module.exports = __webpack_public_path__ + "static/media/real_board_back.536451ed.jpg";